<template><div><h1>VUX V2.2.2 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持 prop:disabled 显示禁用样式</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] 当日期的替代文字为空字符串时，包含日期的 `span` 元素将不显示</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复在某些情况下遮罩被错误关闭的问题 #1312</li>
</ul>
<h2><a href="/zh-CN/components/range.html">Range</a></h2>
<ul><li>[feature] 支持动态设置 step #1394</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[enhance] 在 iOS 键盘上显示 search</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 修复 label for 属性值缺失</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持使用地址文字直接赋值(测试)</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] 支持 prop:dialog-style 覆写原有弹窗容器样式 #1282</li>
</ul>
<h2><a href="/zh-CN/components/x-header.html">XHeader</a></h2>
<ul><li>[feature] 添加 slot:overwrite-left 方便覆写左侧部分</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.2-228.vue?fe5a36b8